import React from 'react'
import { Link } from 'react-router-dom'

import LandingPagePartnerBox from './LandingPagePartnerBox'

function LandingPagePartnersSection({ competitionSlug }) {
  const partners = I18n.t(`competition.${competitionSlug}.partners.main_page_partners`)

  return (
    <section className="content-section content-section--light section--partners">
      <div className="container-fixed">
        <h2 className="content-section__title">Our partners</h2>
        <p className="content-section__subtitle">
          Learn more about our partners who are helping to make this Competition happen and their
          contribution <Link to={`/${competitionSlug}/partners`} className="link--primary-dark">here</Link>
        </p>
        <div className="row">
          {partners.map((partner) => {
            return (
              <LandingPagePartnerBox
                key={partner.slug}
                partner={partner}
                imgPath={require(`images/competitions/digital_art/partners/${partner.slug}.png`)}
              />
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default LandingPagePartnersSection
